import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { authGuard } from '@/plugins/Auth0Lock';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    { path: '/', redirect: '/employees' },
    {
        path: '/rides',
        component: () => import('@/views/DailyRides/Main.vue'),
        beforeEnter: authGuard,
        children: [
            {
                name: 'Rides',
                path: '',
                component: () => import('@/views/DailyRides/DailyRides.vue'),
            },
            {
                name: 'Rides,Passengers List',
                path: ':id/passengers',
                component: () => import('@/views/DailyRides/PassengersList.vue'),
            },
        ],
    },
    {
        path: '/employees',
        component: () => import('@/views/Employees/Main.vue'),
        beforeEnter: authGuard,
        children: [
            {
                name: 'Employees',
                path: '',
                component: () => import('@/views/Employees/Employees.vue'),
            },
            {
                name: 'Employees,Details',
                path: ':id/details',
                component: () => import('@/views/Employees/EmployeeDetails.vue'),
            },
        ],
    },
    {
        path: '/offices',
        name: 'Offices',
        component: () => import('@/views/Offices.vue'),
        beforeEnter: authGuard,
    },
    {
        path: '/reports',
        name: 'Reports',
        component: () => import('@/views/Reports.vue'),
        beforeEnter: authGuard,
    },
    {
        path: '/toasts',
        name: 'Toasts',
        component: () => import('@/views/Toasts.vue'),
        beforeEnter: authGuard,
    },
    {
        path: '/sustainability-report',
        name: 'Sustainability Report',
        component: () => import('@/views/SustainabilityReport.vue'),
        beforeEnter: authGuard,
    },
    {
        path: '/login/:corp',
        name: 'Login',
        redirect: '/employees',
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
